import React, { useEffect, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useDispatch, useSelector } from 'react-redux';
import { updateCompetitivenessData } from '../../redux/graphs';
import Result from '../Result';

/**
 * Ref: https://www.highcharts.com/demo/highcharts/column-stacked
 * 
 */

const Competitiveness = () => {
  const dispatch = useDispatch();

  const competitiveness = useSelector((state) => state.graphs.competitiveness);
  const [options, setOptions] = useState([]);
  // - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    dispatch(
      updateCompetitivenessData()
    );
  }, []);

  useEffect(() => {
    setOptions (
      {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Competitivness',
          align: 'left'
        },
        subtitle: {
          text: 'This measures your individual attitude towards competition in three different orientations',
          align: 'left'
        },
        xAxis: {
          categories: competitiveness.x_labels
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Competitiveness score'
          },
          stackLabels: {
            enabled: true
          }
        },
        legend: {
          align: 'left',
          x: 70,
          verticalAlign: 'top',
          y: 70,
          floating: true,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: competitiveness.data,
      }
    );
  }, [competitiveness]);

  // ==================================================
  // ==================================================
  return(
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />

      <Result
        result_text={"You currently view your overall mental performance as average"}
      />
    </div>
  );
};

export default Competitiveness;